export default Object.freeze({
    DOCUMENT: 'Document',
    JAVASCRIPT: 'JavaScript',
    EXPRESSION: 'Expression',
    LAYOUT: 'Layout',
    BLOCK_REFERENCE: 'Block Reference',
    PARTIAL: 'Partial',
    BLOCK_NAME: 'Named Block'
});
